import React from 'react';
import { AlertTriangle } from 'lucide-react';

const TabWarningModal = ({ showTabWarning, warningLevel, setShowTabWarning }) => {
  if (!showTabWarning) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4">
        <div className="flex items-center mb-4">
          <AlertTriangle className={`w-8 h-8 mr-3 ${warningLevel === 'yellow' ? 'text-yellow-500' : 'text-red-500'}`} />
          <h3 className="text-lg font-bold text-gray-800">
            {warningLevel === 'yellow' ? 'Warning!' : 'Severe Warning!'}
          </h3>
        </div>
        <div className={`p-4 rounded-lg mb-4 ${warningLevel === 'yellow' ? 'bg-yellow-50 border-l-4 border-yellow-400' : 'bg-red-50 border-l-4 border-red-400'}`}>
          <p className="text-gray-700">
            {warningLevel === 'yellow'
              ? 'You have switched tabs 1 time. If you switch tabs 2 more times, the test will be cancelled!'
              : 'You have switched tabs 2 times. If you switch tabs 1 more time, the test will be cancelled immediately!'
            }
          </p>
        </div>
        <div className="flex justify-end">
          <button
            onClick={() => setShowTabWarning(false)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            I understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default TabWarningModal;